import { Maybe } from "@flockcover/flock-svc-core-types"
import { Combobox } from "@shared/primitive-components"

export type DropdownFieldComponentProps = {
  disabled: boolean
  dataTestId?: string
  dropdownValues: ReadonlyArray<string>
  value: Maybe<string>
  setIsOpen: (isOpen: boolean) => void
  onInputValueChange?: (value: string) => void
  onChange: (value: string) => void
}

export const DropdownFieldComponent = ({
  dropdownValues,
  dataTestId,
  value,
  disabled,
  setIsOpen,
  onInputValueChange,
  onChange,
}: DropdownFieldComponentProps) => (
  <Combobox.Root items={dropdownValues} defaultValue={value || ``} onOpenChange={(open) => setIsOpen(open)}>
    <Combobox.Input
      dataTestId={dataTestId}
      disabled={disabled}
      onInputValueChange={onInputValueChange}
      placeholder="Search here"
    />
    <Combobox.Content
      onValueSelect={(selectedValue: string) => {
        onChange(selectedValue)
      }}
    />
  </Combobox.Root>
)

DropdownFieldComponent.defaultProps = {
  dataTestId: undefined,
  onInputValueChange: undefined,
}
